import algoliasearch from "algoliasearch/lite"
import instantsearch from "instantsearch.js"
import { connectClearRefinements } from "instantsearch.js/es/connectors"

function initIndex(getInitialUiState = null) {
    const searchApp = document.querySelector(
        "[data-search-appId]"
    );
    const appId = searchApp.getAttribute("data-search-appId");
    const apiKey = searchApp.getAttribute("data-search-apiKey");
    const indexName = searchApp.getAttribute(
        "data-search-indexName"
    );

    let initialUiState = {};
    if (typeof getInitialUiState === 'function') {
        initialUiState = getInitialUiState();
    }

    const searchClient = algoliasearch(appId, apiKey);
    const siteSearch = instantsearch({
        indexName,
        searchClient: searchClient,
        future: {
            preserveSharedStateOnUnmount: true
        },
        initialUiState: {
            [indexName]: initialUiState
        }
    });

    return siteSearch;
}

const refinementCssClasses = {
    showMore: "btn btn-outline-light btn-sm",
    labelText: "p-1",
    count: "d-none", // "badge bg-primary",
    list: "list-group list-group-flush",
    item: "list-group-item"
}

const rangeInputCssClasses = {
    input: "form-control",
    submit: "btn btn-primary btn-sm",
    label: "p-1"
}

const renderClearRefinements = (renderOptions, isFirstRender) => {
    const { canRefine, refine, widgetParams } = renderOptions;

    if (isFirstRender) {
        const button = document.createElement("button");
        button.className = "btn btn-outline-light btn-sm";
        button.textContent = "Clear Filters";

        button.addEventListener("click", () => {
            refine();
        });

        widgetParams.container.appendChild(button);
    }

    widgetParams.container.querySelector("button").disabled = !canRefine;
};

const customClearRefinements = connectClearRefinements(
    renderClearRefinements
);

export { initIndex, customClearRefinements, refinementCssClasses, rangeInputCssClasses }